<script setup lang="ts">
import { cartBus } from '@/event/cartBus'
import { setRemoveProductMessage } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import { onMounted, ref, watch } from 'vue'

const props = defineProps<{ index: number }>()

const counterBasket = ref(0)

function increment() {
    counterBasket.value++
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value - 1
        const price = cartBus.value[props.index].total_price / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
    }
}

function decrement() {
    // counterBasket.value--
    if (counterBasket.value > 1) {
        const countElement = counterBasket.value
        counterBasket.value--

        const price = cartBus.value[props.index].total_price / countElement

        cartBus.value[props.index].quantity = counterBasket.value
        cartBus.value[props.index].total_price = price * counterBasket.value
    } else if (counterBasket.value === 1) {
        const product = cartBus.value[props.index]
        setRemoveProductMessage(product)
        // cartBus.value.splice(props.index, 1)
    }
}

onMounted(() => {
    if (cartBus.value) {
        counterBasket.value = cartBus.value[props.index].quantity ?? 0
    }
})
</script>

<template>
    <section class="section-button-select-basket-happy">
        <div class="min-w-5 min-h-5">
            <button
                class="button-minus-basket-happy"
                @click.stop="decrement()"
                v-if="counterBasket >= 1"
            >
                <svg
                    class="svg-minus-happy"
                    viewBox="0 0 15 2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 1H14"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
        <p class="text-counter-option-value-happy">{{ counterBasket }}</p>

        <button class="button-plus-basket-happy" @click.stop="increment()">
            <svg
                class="svg-plus-happy"
                viewBox="0 0 17 17"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 8.5H16M8.5 1V16"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>
    </section>
</template>

<style scoped>
.section-button-select-basket-happy {
    @apply flex items-center justify-between gap-2 min-w-16 max-w-24 h-full;
}

.button-minus-basket-happy {
    @apply flex items-center border border-button-yellow-happy-light bg-bg-happy-light rounded-[5px] p-1;
}

.svg-minus-happy {
    @apply w-3 h-3 stroke-text-dark-happy-light;
}

.text-counter-option-value-happy {
    @apply happy-light:text-text-dark-happy-light happy-dark:text-bg-happy-light text-lg text-center w-6 font-semibold;
}

.button-plus-basket-happy {
    @apply flex items-center border border-button-yellow-happy-light bg-button-yellow-happy-light p-1 rounded-[5px];
}
.svg-plus-happy {
    @apply w-3 h-3 stroke-text-dark-happy-light;
}

.button-minus-basket-happy:active .svg-minus-happy {
    @apply stroke-bg-happy-light;
}
.button-minus-basket-happy:active,
.button-plus-basket-happy:active {
    @apply bg-hover-yellow-happy border-bg-happy-light;
}
@media (hover: hover) {
    .button-plus-basket-happy:hover {
        @apply bg-hover-yellow-happy border-bg-happy-light;
    }
    .button-minus-basket-happy:hover .svg-minus-happy {
        @apply stroke-bg-happy-light;
    }
    .button-minus-basket-happy:hover {
        @apply bg-hover-yellow-happy border-bg-happy-light;
    }
}
</style>
